module.exports = __webpack_public_path__ + "static/media/teygja_armbeygja_small.508187d9.png";